import axios from "axios";

const axiosClient = axios.create();

//axiosClient.defaults.baseURL = "";


// axiosClient.defaults.headers = {
//   "Content-Type": "application/json",
//   Accept: "application/json",
//   "x-api-key" : "E291B0C63C72FD59FC08C034D5DD5D4B"
// };

//All request will wait 2 seconds before timeout
 axiosClient.defaults.timeout = 4000;
axiosClient.defaults.withCredentials = true;
export function getRequest(URL) {
  return axiosClient.get(URL).then((response) => response);
}

export function postRequest(URL, payload, headers) {
  return axiosClient.post(URL, payload, {
    "headers": headers
  })
  .then((response) => response);
}
